"use client";

import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { fetchCountries, type CountriesQueryParams } from "@/entities/country/api/countries";
import { isApiError } from "@/shared/api/common";
const ONE_HOUR = 60 * 60 * 1000;
export const allCountriesQueryKey = ["countries", "list", "", 1, "all", null] as const;
export function useCountriesQuery(t0) {
  const $ = _c(16);
  let enabled;
  let queryParams;
  let t1;
  if ($[0] !== t0) {
    const params = t0 === undefined ? {} : t0;
    const {
      enabled: t2,
      ...t3
    } = params;
    queryParams = t3;
    enabled = t2 === undefined ? true : t2;
    t1 = queryParams.search?.trim() ?? "";
    $[0] = t0;
    $[1] = enabled;
    $[2] = queryParams;
    $[3] = t1;
  } else {
    enabled = $[1];
    queryParams = $[2];
    t1 = $[3];
  }
  const trimmedSearch = t1;
  const page = queryParams.page ?? 1;
  const limit = queryParams.limit ?? 100;
  const parentId = queryParams.parentId ?? null;
  let t2;
  if ($[4] !== limit || $[5] !== page || $[6] !== parentId || $[7] !== trimmedSearch) {
    t2 = trimmedSearch === "" && page === 1 && limit === "all" && parentId === null ? allCountriesQueryKey : ["countries", "list", trimmedSearch, page, limit, parentId] as const;
    $[4] = limit;
    $[5] = page;
    $[6] = parentId;
    $[7] = trimmedSearch;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const queryKey = t2;
  let t3;
  if ($[9] !== queryParams || $[10] !== trimmedSearch) {
    t3 = () => fetchCountries({
      ...queryParams,
      search: trimmedSearch
    });
    $[9] = queryParams;
    $[10] = trimmedSearch;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== enabled || $[13] !== queryKey || $[14] !== t3) {
    t4 = {
      queryKey,
      queryFn: t3,
      enabled,
      staleTime: ONE_HOUR,
      retry: _temp
    };
    $[12] = enabled;
    $[13] = queryKey;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return useQuery(t4);
}
function _temp(failureCount, error) {
  if (isApiError(error) && (error.status === 404 || error.status === 403)) {
    return false;
  }
  return failureCount < 3;
}
export function useAllCountriesQuery(t0) {
  const $ = _c(4);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const params = t1;
  let t2;
  if ($[2] !== params.enabled) {
    t2 = {
      limit: "all",
      enabled: params.enabled
    };
    $[2] = params.enabled;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return useCountriesQuery(t2);
}